// These are not proper "actions", but are used to record the different
// types/features of auth requests. They are here for completion's sake.
export enum AuthActionTypes {
  Login = '[auth] Login',
  Forgot = '[auth] Forgot Password',
  Reset = '[auth] Reset Password',
  OIDCCallback = '[auth] OIDC Callback',
}
